import React, { FC } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ScannerCaseRestoration } from 'models/scanner-case';
import InfoText from 'components/shared/info-text.component';
import { formatTeethList } from 'utils/teeth';

type RestorationsTableProps = {
    restorations: ScannerCaseRestoration[];
};
const RestorationsTable: FC<RestorationsTableProps> = ({ restorations }) => {
    const { t: translate } = useTranslation(['common', 'scan-cases']);

    const getIcon = (iconUrl?: string) => {
        if (iconUrl && iconUrl !== '') {
            return <img src={iconUrl} alt="icon" style={{ width: 15, height: 15, marginRight: 8 }} />;
        }
        return undefined;
    };

    const getTeethDescription = (restoration: ScannerCaseRestoration) => {
        if (restoration.teethNumbers && restoration.teethNumbers.length > 0) {
            return formatTeethList(restoration.teethNumbers);
        } else if (restoration.jaw) {
            return translate(`orders:${restoration.jaw}`);
        }
        return '';
    };

    return (
        <TableContainer>
            <Table size="small">
                <TableHead sx={{ borderBottom: 'none' }}>
                    <TableRow>
                        <TableCell>{translate('common:DESCRIPTION')}</TableCell>
                        <TableCell>{translate('common:TEETH')}</TableCell>

                        <TableCell>{translate('scan-cases:MATERIAL')}</TableCell>
                        <TableCell>{translate('scan-cases:COLOR')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {restorations.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={4}>
                                <InfoText text={translate('scan-cases:NO_CONSTRUCTIONS_ON_SCAN_CASE')} />
                            </TableCell>
                        </TableRow>
                    ) : (
                        restorations.map((restoration: ScannerCaseRestoration, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <Box display="flex" alignItems="center">
                                        {getIcon(restoration.iconUrl)}
                                        <Box>{restoration.product}</Box>
                                    </Box>
                                </TableCell>
                                <TableCell>{getTeethDescription(restoration)}</TableCell>
                                <TableCell>{restoration.material}</TableCell>
                                <TableCell>{restoration.shade}</TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RestorationsTable;
